import React from "react";
import { Route, Switch } from "react-router-dom";
import { Login } from "./pages/login/login";
import { AuthProvider } from "./auth";
import { PrivateRoute } from "./utils/private-route";
import { Portal } from "./pages/portal";
import AnalyticsProvider from "./utils/analytics/analytics-context";
import "./App.css";
import { Pdf } from "./pages/pdf";
import { StoreProvider } from "./store";

export const App: React.FunctionComponent = () => {
  return (
    <div className="App">
      <AnalyticsProvider>
        <AuthProvider>
          <StoreProvider>
            <Switch>
              <Route exact path="/login" component={Login} />
              <PrivateRoute path={"/pdf"} component={Pdf} />
              <PrivateRoute path="/" component={Portal} />
            </Switch>
          </StoreProvider>
        </AuthProvider>
      </AnalyticsProvider>
    </div>
  );
};
